<template>
<div id="app" class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav selectedLanguage="en" page="gb" :apk="apk"/>

  <div id="page" class="site container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <!-- Hero Section：Logo + 下载按钮提前，再放首段介绍 -->
          <section class="hero-section">
            <div class="container">
              <div class="hero-panel">
              <h1>GB WhatsApp Download APK – Latest Version 2026</h1>

              <div class="hero-image">
                <img src="@/assets/home/GB.webp" style="width: 300px;" alt="GB WhatsApp App" />
              </div>

              <div class="download-button-container hero-download-below-main-logo">
                <button type="button" class="download-btn" @click="gotodownload()">
                  <svg class="download-btn-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path fill="currentColor" d="M12 3a1 1 0 0 1 1 1v8.59l2.3-2.3a1 1 0 1 1 1.4 1.42l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 1 1 1.4-1.42L11 12.59V4a1 1 0 0 1 1-1Zm-7 14a1 1 0 0 1 1 1v1h12v-1a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1Z"/>
                  </svg>
                  <span>Click To Download File</span>
                </button>
              </div>

              <div class="hero-copy">
              <p>
                <a href="/" class="hero-self-link"><strong>GB WhatsApp</strong></a> is a powerful unofficial modified version of the original WhatsApp app, offering extra features not available in the official version.
              </p>
              <p>
                Download the latest <strong>GB WhatsApp APK</strong> below to enjoy enhanced messaging, personalized chat styles, and more flexible settings on your Android device.
              </p>

              </div>
              </div>

              <!-- GB WhatsApp App Details Table -->
              <div class="app-details-section">
                <h2 id="gb-whatsapp-app">GB WhatsApp App</h2>
                <div class="table-container">
                  <table>
                    <tbody>
                      <tr>
                        <td><strong>Package name</strong></td>
                        <td>GBWhatsApp-18.80</td>
                      </tr>
                      <tr>
                        <td><strong>Version</strong></td>
                        <td>18.8</td>
                      </tr>
                      <tr>
                        <td><strong>File size</strong></td>
                        <td>91.2 MB</td>
                      </tr>
                      <tr>
                        <td><strong>Updated</strong></td>
                        <td>2 Days Ago</td>
                      </tr>
                      <tr>
                        <td><strong>Minimum Android version</strong></td>
                        <td>Android 5.0 (Lollipop, API 21)</td>
                      </tr>
                      <tr>
                        <td><strong>Screen DPI</strong></td>
                        <td>nodpi</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>

          <!-- 目录：默认折叠 -->
          <section class="toc-section">
            <div class="container">
              <div id="toc_container" class="no_bullets home-toc" :class="{ 'is-expanded': showTableOfContents }">
                <p class="toc-header" @click="showTableOfContents = !showTableOfContents">
                  <strong>Table of Contents</strong>
                  <span class="toc-toggle">{{ showTableOfContents ? '−' : '+' }}</span>
                </p>
                <ul v-show="showTableOfContents" class="toc-list">
                  <li v-for="(item, index) in tocItems" :key="item.id">
                    <a :href="'#' + item.id">
                      <span class="toc-num">{{ index + 1 }}.</span>
                      <span class="toc-label">{{ item.label }}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <!-- What's New（替换原 Latest APK / What is） -->
          <section class="whats-new-section">
            <div class="container">
              <h2 id="whats-new">What's New in GB WhatsApp v18.80</h2>
              <p>The latest GB WhatsApp update introduces improved anti-ban protection, better performance, bug fixes, and compatibility with the latest Android versions. Users can also enjoy smoother media sharing, enhanced privacy options, and a more stable messaging experience.</p>

              <div class="apk-image">
                <img src="@/assets/home/home-2.webp" alt="GB WhatsApp Latest APK" />
              </div>
            </div>
          </section>

          <section class="worth-downloading-section">
            <div class="container">
              <h2 id="worth-downloading">Is GB WhatsApp Worth Downloading?</h2>
              <p>If you mainly use WhatsApp for basic messaging, the official app is enough. However, if you want more privacy settings, personalized themes, larger file sharing, and additional messaging tools, GB WhatsApp offers features that many Android users appreciate.</p>
            </div>
          </section>

          <!-- Features：标题 → 卡片 → 表格 -->
          <section class="features-section">
            <div class="container">
              <h2 id="features">Features of GB WhatsApp Mod</h2>

              <div class="enhanced-feature-grid">
                <div class="enhanced-feature-card">
                  <h3>Enhanced Privacy</h3>
                  <p>GB WhatsApp gives you full control over your privacy. You can hide your last seen, blue ticks, online status, and even typing indicators. This ensures that you can chat without worrying about being constantly monitored.</p>
                </div>

                <div class="enhanced-feature-card">
                  <h3>Custom Themes & Fonts</h3>
                  <p>Personalize your WhatsApp experience with GB WhatsApp. Change chat backgrounds, colors, and fonts according to your style. You can also download and apply themes created by other users to completely transform the app's interface.</p>
                </div>

                <div class="enhanced-feature-card">
                  <h3>Extended Media Sharing</h3>
                  <p>Share media without limits. GB WhatsApp allows you to send large videos, multiple images at once, and high-quality files, making it easier to share important content with friends and family.</p>
                </div>

                <div class="enhanced-feature-card">
                  <h3>Dual Account Support</h3>
                  <p>Manage two WhatsApp accounts on a single Android device seamlessly. This is perfect for separating personal and professional conversations without carrying multiple phones.</p>
                </div>

                <div class="enhanced-feature-card">
                  <h3>Message Scheduling & Auto Reply</h3>
                  <p>Schedule messages for birthdays, reminders, or greetings in advance. You can also set automatic replies for your contacts, making communication more convenient and organized.</p>
                </div>

                <div class="enhanced-feature-card">
                  <h3>Anti-Ban Protection</h3>
                  <p>GB WhatsApp includes built-in anti-ban features to reduce the risk of being blocked. This ensures safer usage compared to other modified WhatsApp versions.</p>
                </div>

                <div class="enhanced-feature-card">
                  <h3>Status Download</h3>
                  <p>Easily download photos and videos from your contacts' WhatsApp statuses. Save memorable moments directly to your device without using additional apps.</p>
                </div>

                <div class="enhanced-feature-card">
                  <h3>Improved Performance</h3>
                  <p>GB WhatsApp is optimized for faster messaging, media loading, and chat management. Even with large files or many active chats, the app runs smoothly.</p>
                </div>
              </div>

              <div class="table-container features-table-below-cards">
                <table>
                  <thead>
                    <tr>
                      <th>Feature</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>Customization Options</strong></td>
                      <td>Choose and apply custom themes, Change fonts, icons, and UI elements</td>
                    </tr>
                    <tr>
                      <td><strong>Increased Privacy Control</strong></td>
                      <td>Hide "Last Seen" status, Disable blue ticks (read receipts), Anti-delete messages and status, Freeze "Last Seen" status</td>
                    </tr>
                    <tr>
                      <td><strong>Enhanced Media Sharing</strong></td>
                      <td>Send larger files (video up to 50MB, audio up to 100MB), Maintain original image quality</td>
                    </tr>
                    <tr>
                      <td><strong>Multiple Accounts</strong></td>
                      <td>Run multiple WhatsApp accounts on the same device</td>
                    </tr>
                    <tr>
                      <td><strong>Auto Reply</strong></td>
                      <td>Set up automated responses when unavailable</td>
                    </tr>
                    <tr>
                      <td><strong>Message Scheduler</strong></td>
                      <td>Schedule messages to send at a later time</td>
                    </tr>
                    <tr>
                      <td><strong>Anti-Ban Feature</strong></td>
                      <td>Protects against potential bans by WhatsApp for using a modified version</td>
                    </tr>
                    <tr>
                      <td><strong>Customization of Notifications</strong></td>
                      <td>Customize notification sounds, icons, and vibration patterns</td>
                    </tr>
                    <tr>
                      <td><strong>Media Preview</strong></td>
                      <td>Preview media in a chat without downloading</td>
                    </tr>
                    <tr>
                      <td><strong>DND Mode</strong></td>
                      <td>Enable "Do Not Disturb" mode to stop notifications without turning off the internet</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>

          <!-- Call ID Section -->
          <section class="call-id-section">
            <div class="container">
              <h3 id="call-id">Call ID in GB WhatsApp</h3>
              <p>Call ID in GB WhatsApp allows you to see the caller's information before answering a voice or video call. Unlike the official WhatsApp, some GB WhatsApp versions may offer additional details like custom caller names or profile picture previews, enhancing your ability to identify who is calling.</p>
              
              <strong>Key Points:</strong>
              <ul>
                <li>Shows caller information instantly.</li>
                <li>Works for both voice and video calls.</li>
                <li>Helps avoid unknown or unwanted calls.</li>
              </ul>
            </div>
          </section>

          <!-- Requirements：放到安装教程前面 -->
          <section class="requirements-section">
            <div class="container">
              <h2 id="requirements">Requirements to Install GB WhatsApp</h2>
              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Requirement</th>
                      <th>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>Internet Connection</strong></td>
                      <td>WiFi Connection is recommended</td>
                    </tr>
                    <tr>
                      <td><strong>Location of the Device</strong></td>
                      <td>Access to Gallery</td>
                    </tr>
                    <tr>
                      <td><strong>Access to Contacts</strong></td>
                      <td>WiFi Connection is recommended</td>
                    </tr>
                    <tr>
                      <td><strong>Device Identity</strong></td>
                      <td>External Storage Access</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>

          <!-- Download and Install Guide Section -->
          <section class="download-install-section step-timeline">
            <div class="container">
              <h2 id="download-install">How to Download And Install GB WhatsApp APK 2026</h2>
              <p>If you want to enjoy advanced messaging features beyond the official WhatsApp, installing <strong>GB WhatsApp</strong> APK is the way to go. Follow these simple steps to safely download, install, and set up GB WhatsApp on your Android device.</p>
              
              <div class="step">
                <h3>Step 1: Enable Installation from Unknown Sources</h3>
                <p>Since <strong>GB WhatsApp</strong> is a modified version of the official WhatsApp, it is not available on the Google Play Store. To install the APK, you first need to enable installation from unknown sources:</p>
                <ol>
                  <li>Open your phone's <strong>Settings</strong>.</li>
                  <li>Navigate to <strong>Security</strong> or <strong>Apps & Notifications</strong>.</li>
                  <li>Toggle on <strong>Install from Unknown Sources</strong> or <strong>Allow from this source</strong> for your browser or file manager.</li>
                </ol>
                <p>This step is crucial to allow the <strong>GB WhatsApp download APK</strong> to install properly.</p>
              </div>

              <div class="step">
                <h3>Step 2: Download and Install the APK</h3>
                <p>After enabling unknown sources, download the latest <strong>GB WhatsApp APK</strong> from a trusted source. Once downloaded:</p>
                <ol>
                  <li>Locate the APK file in your <strong>Downloads</strong> folder or file manager.</li>
                  <li>Tap the file to start installation.</li>
                  <li>Follow the on-screen instructions to complete the installation.</li>
                </ol>
                <p>By using the <strong>GB WhatsApp download</strong>, you get access to advanced features like custom themes, auto-reply, ghost mode, and larger media sharing.</p>
              </div>

              <div class="step">
                <h3>Step 3: Set Up GB WhatsApp</h3>
                <p>Once installed, open <strong>GB WhatsApp</strong> and set it up using your phone number:</p>
                <ul>
                  <li>Verify your number just like in the official WhatsApp.</li>
                  <li>Restore your previous chats if you are switching from WhatsApp.</li>
                  <li>Customize your chat interface, privacy settings, and notifications to your liking.</li>
                </ul>
                <p>With <strong>GB WhatsApp download</strong>, you can run dual accounts, schedule messages, and unlock advanced privacy tools for a complete messaging experience.</p>
              </div>

              <div class="update-section">
                <h2>Update GB WhatsApp</h2>
                <p>To update to the latest version:</p>
                <ol>
                  <li><strong>Backup Your Chats:</strong> Ensure your conversations are backed up to avoid data loss.</li>
                  <li><strong>Download the APK:</strong> Obtain the GB WhatsApp v18.80 APK from a trusted source.</li>
                  <li><strong>Enable Unknown Sources:</strong> Go to your device's settings and allow installations from unknown sources.</li>
                  <li><strong>Install the APK:</strong> Locate the downloaded file and install it.</li>
                  <li><strong>Restore Chats:</strong> Open the app and restore your chats from the backup.</li>
                </ol>
              </div>
            </div>
          </section>

          <!-- GB WhatsApp Old Version Download Section -->
          <section class="old-version-section">
            <div class="container">
              <h2 id="old-version">GB WhatsApp Old Version Download</h2>
              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Version</th>
                      <th>Year</th>
                      <th>Key Updates / Features</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>v18.30</td>
                      <td>2024</td>
                      <td>Added more themes, improved message recall, fixed crash issues</td>
                    </tr>
                    <tr>
                      <td>v17.80</td>
                      <td>2023</td>
                      <td>Enhanced anti-ban, privacy options, improved group chat forwarding</td>
                    </tr>
                    <tr>
                      <td>v17.20</td>
                      <td>2023</td>
                      <td>Auto-reply messages, larger video sharing, status download feature</td>
                    </tr>
                    <tr>
                      <td>v16.90</td>
                      <td>2022</td>
                      <td>Dark mode optimization, faster media loading, bug fixes</td>
                    </tr>
                    <tr>
                      <td>v16.00</td>
                      <td>2022</td>
                      <td>More stickers and emojis, multi-account support, minor bug fixes</td>
                    </tr>
                    <tr>
                      <td>v15.60</td>
                      <td>2021</td>
                      <td>Anti-delete messages, hide group notifications, improved multi-language support</td>
                    </tr>
                    <tr>
                      <td>v14.00</td>
                      <td>2020</td>
                      <td>New UI design, improved voice/video calls, more chat wallpapers</td>
                    </tr>
                    <tr>
                      <td>v12.00</td>
                      <td>2019</td>
                      <td>Larger image sharing, custom fonts, early compatibility fixes</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>

          <!-- Safety and Privacy Section -->
          <section class="safety-privacy-section">
            <div class="container">
              <h2 id="safety">Safety and Privacy Considerations</h2>
              <p>While <strong>GB WhatsApp</strong> offers powerful features, it's important to understand the risks of using a third-party modified app:</p>

              <div class="card-grid card-grid--2x2">
                <div class="safety-item">
                  <h3>Security Risks</h3>
                  <p>Since <strong>GB WhatsApp APK</strong> is not official, downloading it from untrusted sources may expose your device to malware or spyware. Always use verified platforms for your GB WhatsApp download.</p>
                </div>

                <div class="safety-item">
                  <h3>Privacy Concerns</h3>
                  <p>Some features modify core WhatsApp functions, which could compromise your personal data. Unlike the official app, <strong>GB WhatsApp</strong> does not implement the same encryption guarantees.</p>
                </div>

                <div class="safety-item">
                  <h3>Account Ban</h3>
                  <p>Although <strong>GB WhatsApp</strong> includes anti-ban measures, WhatsApp can still detect modified apps and temporarily or permanently suspend your account. Using a secondary number is recommended for testing.</p>
                </div>

                <div class="safety-item">
                  <h3>Updates and Support</h3>
                  <p><strong>GB WhatsApp</strong> does not receive automatic updates via Google Play Store. To stay secure and enjoy new features, you must manually download the latest <strong>GB WhatsApp APK</strong> from trusted sources regularly.</p>
                </div>
              </div>

              <div class="why-use-section">
                <h2>Why Use GB WhatsApp ?</h2>
                <p>Using the latest <strong>GB WhatsApp</strong> gives you:</p>
                <ul>
                  <li><strong>Enhanced Privacy:</strong> Hide online status, blue ticks, and typing indicators.</li>
                  <li><strong>Customization:</strong> Change themes, fonts, chat backgrounds, and interface layouts.</li>
                  <li><strong>Expanded Media Sharing:</strong> Send larger files, multiple images, and high-quality videos.</li>
                  <li><strong>Automation Tools:</strong> Auto-reply, message scheduling, and broadcast messages.</li>
                </ul>
                <p>By following this guide, you can safely install <strong>GB WhatsApp APK</strong> and enjoy a powerful messaging experience with more control than the official app.</p>
              </div>

              <div class="privacy-tips-section">
                <h2>GB WhatsApp Privacy & Security Tips</h2>
                <p>Using <strong>GB WhatsApp</strong> safely requires caution since it's a third-party app. Here are important privacy and security tips:</p>
                <ul>
                  <li><strong>Download from Trusted Sources:</strong> Only use reputable platforms to avoid malware risks.</li>
                  <li><strong>Use a Secondary Number:</strong> To protect your primary account from potential bans, consider using a secondary phone number.</li>
                  <li><strong>Regular Backups:</strong> Back up chats frequently to avoid losing important data.</li>
                  <li><strong>Avoid Suspicious Links:</strong> Do not click unknown links in chats to reduce the risk of malware or phishing attacks.</li>
                  <li><strong>Keep Updated:</strong> Regularly download the latest <strong>GB WhatsApp APK</strong> to patch vulnerabilities and enjoy new features.</li>
                </ul>
              </div>
            </div>
          </section>

          <!-- Comparison Section：合并 vs / Difference 为一块 -->
          <section class="comparison-section">
            <div class="container">
              <h2 id="comparison">GB WhatsApp vs Official WhatsApp</h2>
              <p>GB WhatsApp and the official WhatsApp app share the same basic messaging experience, but they differ in customization, privacy options, and additional tools. The comparison below highlights the main differences between the two versions.</p>

              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Feature</th>
                      <th>Official WhatsApp</th>
                      <th>GB WhatsApp</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Customization</td>
                      <td>Limited themes and appearance options</td>
                      <td>Custom themes, fonts, wallpapers, and styles</td>
                    </tr>
                    <tr>
                      <td>Privacy Controls</td>
                      <td>Basic privacy settings</td>
                      <td>Advanced options like hiding online status, blue ticks, and typing status</td>
                    </tr>
                    <tr>
                      <td>Media Sharing</td>
                      <td>Standard file and media limits</td>
                      <td>Larger file sharing and more flexible media options</td>
                    </tr>
                    <tr>
                      <td>Auto Reply</td>
                      <td>Not available</td>
                      <td>Available</td>
                    </tr>
                    <tr>
                      <td>Message Scheduling</td>
                      <td>Not available</td>
                      <td>Available</td>
                    </tr>
                    <tr>
                      <td>Status Download</td>
                      <td>Not available</td>
                      <td>Available</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>

          <!-- Tutorial Sections -->
          <section class="tutorial-section">
            <div class="container">
              
              <div class="tutorial-item">
                <h2 id="tutorials">Restore Chat in GB WhatsApp</h2>
                <div class="tutorial-steps">
                  <strong>1. Backup Your Chats First</strong>
                  <ul>
                    <li>Open GB WhatsApp → <strong>Settings</strong> → <strong>Chats</strong> → <strong>Backup</strong>.</li>
                    <li>Tap <strong>Back Up</strong> to save your conversations to your device or Google Drive (if supported).</li>
                  </ul>
                  
                  <strong>2. Uninstall & Reinstall GB WhatsApp</strong>
                  <ul>
                    <li>Download the latest GB WhatsApp APK from a trusted source.</li>
                    <li>Uninstall the old version (optional if updating).</li>
                    <li>Install the new APK.</li>
                  </ul>
                  
                  <strong>3. Verify Your Phone Number</strong>
                  <ul>
                    <li>Open GB WhatsApp and enter the same phone number used previously.</li>
                  </ul>
                  
                  <strong>4. Restore Chats</strong>
                  <ul>
                    <li>After verification, GB WhatsApp will detect the backup automatically.</li>
                    <li>Tap <strong>Restore</strong> to retrieve your previous conversations and media.</li>
                  </ul>
                </div>
              </div>

              <div class="tutorial-item">
                <h2>Disable Double Tick in GB WhatsApp</h2>
                <div class="tutorial-steps">
                  <ol>
                    <li>Open <strong>GB WhatsApp</strong> on your Android device.</li>
                    <li>Tap the <strong>three-dot menu</strong> in the top-right corner.</li>
                    <li>Select <strong>GB Settings</strong> → <strong>Privacy & Security</strong>.</li>
                    <li>Look for <strong>Hide Blue Ticks / Double Tick</strong> options:
                      <ul>
                        <li><strong>Hide Blue Ticks:</strong> Prevents others from knowing you've read their messages.</li>
                        <li><strong>Hide Second Tick:</strong> Hides the second tick, so messages appear as "sent" but not "delivered."</li>
                      </ul>
                    </li>
                    <li>Toggle the options <strong>ON</strong> as desired.</li>
                  </ol>
                </div>
              </div>

              <div class="tutorial-item">
                <h2>Change GB WhatsApp Home Screen Wallpaper</h2>
                <div class="tutorial-steps">
                  <ol>
                    <li>Open <strong>GB WhatsApp</strong> on your Android device.</li>
                    <li>Tap the <strong>three-dot menu</strong> in the top-right corner.</li>
                    <li>Select <strong>Settings</strong> → <strong>Chats</strong>.</li>
                    <li>Tap <strong>Wallpaper</strong>.</li>
                    <li>Choose a wallpaper source:
                      <ul>
                        <li><strong>Gallery:</strong> Select an image from your phone.</li>
                        <li><strong>Solid Colors:</strong> Pick a plain color.</li>
                        <li><strong>GB Wallpaper Library:</strong> Browse built-in wallpapers.</li>
                      </ul>
                    </li>
                    <li>Adjust the wallpaper if needed and tap <strong>Set Wallpaper</strong>.</li>
                  </ol>
                  <p><strong>✅ Tip:</strong> You can also change the <strong>chat screen wallpaper</strong> separately for individual chats by opening a chat → three-dot menu → Wallpaper.</p>
                </div>
              </div>

              <div class="tutorial-item">
                <h2>Hide a Chat in GB WhatsApp</h2>
                <div class="tutorial-steps">
                  <ol>
                    <li><strong>Open GB WhatsApp</strong> - Launch the app and go to your <strong>chat list</strong>.</li>
                    <li><strong>Select the chat to hide</strong> - Tap and <strong>hold</strong> the chat you want to hide until it's highlighted.</li>
                    <li><strong>Choose "Hide" option</strong>
                      <ul>
                        <li>Tap the <strong>three-dot menu</strong> at the top-right corner.</li>
                        <li>Select "<strong>Hide</strong>" from the dropdown.</li>
                        <li>Alternatively, in some GB WhatsApp versions, you may see a <strong>lock or eye icon</strong> when holding the chat.</li>
                      </ul>
                    </li>
                    <li><strong>Set a password or pattern</strong>
                      <ul>
                        <li>GB WhatsApp will ask you to set a <strong>PIN, password, or pattern</strong> if you haven't already.</li>
                        <li>This password protects all hidden chats.</li>
                      </ul>
                    </li>
                    <li><strong>Chat is hidden</strong>
                      <ul>
                        <li>The chat will disappear from the main chat list.</li>
                        <li>To access it, you need to <strong>enter your password/pattern</strong>.</li>
                      </ul>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </section>

          <!-- Alternatives Section -->
          <section class="alternatives-section">
            <div class="container">
              <h2 id="alternatives">GB WhatsApp Alternatives – MOD Versions</h2>
              <p>If you enjoy GB WhatsApp, there are several similar MOD APKs with enhanced features, privacy options, and customization:</p>

              <div class="card-grid card-grid--2x2">
                <div class="alternative-item">
                  <h3><a href="/fm-whatsapp/">FM WhatsApp (FM)</a></h3>
                  <p>Developed by Fouad Mokdad, FM WhatsApp is one of the most actively maintained mods. It features a rich built-in theme store, granular privacy controls, dual account support, and monthly updates — making it one of the closest rivals to GB WhatsApp in terms of update frequency and feature quality.</p>
                </div>

                <div class="alternative-item">
                  <h3><a href="/jt-whatsapp/">JT WhatsApp (JT)</a></h3>
                  <p>JT WhatsApp is a lightweight alternative ideal for users on older or budget Android devices. It delivers essential MOD features — privacy settings, anti-delete messages, dual accounts — in a compact APK that won't strain your device's resources.</p>
                </div>

                <div class="alternative-item">
                  <h3><a href="/yo-whatsapp/">YoWhatsApp (Yo)</a></h3>
                  <p>YoWhatsApp stands out with its polished UI, thousands of community themes, freeze last seen feature, and extended video status duration up to 7 minutes. It's particularly popular among users who prioritize visual customization alongside solid privacy controls.</p>
                </div>

                <div class="alternative-item">
                  <h3><a href="/og-whatsapp/">OG WhatsApp (OG)</a></h3>
                  <p>One of the original WhatsApp mods, OG WhatsApp pioneered multi-account and extended media sharing features. It's a stable, no-frills option that has been refined over many years. Updates are slower compared to GB WhatsApp, but its core functionality remains solid.</p>
                </div>

                <div class="alternative-item">
                  <h3><a href="/red-whatsapp/">Red WhatsApp (Red)</a></h3>
                  <p>Red WhatsApp offers a visually distinctive experience with its bold red UI, custom animations, and privacy-focused features. It caters to users who want a messaging app that makes a design statement — a niche but passionate community surrounds this mod.</p>
                </div>
              </div>
            </div>
          </section>

          <!-- FAQ Section -->
          <section class="faq-section">
            <div class="container">
              <h2 id="faq">Frequently Asked Questions (FAQs)</h2>
              
              <div class="faq-accordion">
                <div
                  v-for="(item, index) in faqItems"
                  :key="item.question"
                  class="faq-item"
                  :class="{ 'is-open': openFaqIndex === index }"
                >
                  <button
                    type="button"
                    class="faq-question"
                    :aria-expanded="openFaqIndex === index ? 'true' : 'false'"
                    :aria-controls="`faq-answer-${index}`"
                    @click="toggleFaq(index)"
                  >
                    <span>{{ item.question }}</span>
                    <span class="faq-icon" aria-hidden="true"></span>
                  </button>

                  <div
                    v-show="openFaqIndex === index"
                    :id="`faq-answer-${index}`"
                    class="faq-answer"
                  >
                    <p><strong>{{ item.answerLabel }}</strong> {{ item.answer }}</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- Conclusion Section -->
          <section class="conclusion-section">
            <div class="container">
              <h2 id="conclusion">Conclusion</h2>
              <p>The GBWhatsApp APK is ideal choice for any user who seeks more than the standard WhatsApp app might provide. It offers more privacy control compared to the typical version, better media share options, and customization features that make it unique.</p>
              <p>However, with all these benefits comes a concerned aspect, which is about possible risks facing such issues like account bans and security issues. Always ensure you download the APK from trusted sources, and take proper precautions to protect your data.</p>
            </div>
          </section>

          <!-- GB WhatsApp Link：放到最底部 -->
          <section class="link-section">
            <div class="container">
              <h2 id="gb-link">GB WhatsApp link</h2>
              <p>Looking for a reliable <strong>GB WhatsApp</strong> link? Here you can access the latest and safe APK download for Android. Our verified GB WhatsApp link ensures a secure installation process, letting you enjoy the newest features and enhanced privacy without any risk. Always download from trusted sources to keep your device safe.</p>

              <div class="download-button-container">
                <button class="download-btn" @click="gotodownload()">
                  <svg class="download-btn-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path fill="currentColor" d="M12 3a1 1 0 0 1 1 1v8.59l2.3-2.3a1 1 0 1 1 1.4 1.42l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 1 1 1.4-1.42L11 12.59V4a1 1 0 0 1 1-1Zm-7 14a1 1 0 0 1 1 1v1h12v-1a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1Z"/>
                  </svg>
                  <span>Download GB WhatsApp link</span>
                </button>
              </div>
            </div>
          </section>
        </main> 
      </div>
    </div>
  </div>

  <!-- <div v-if="$global.isMobileDevice()" id="fixed-bottom-btn" class="fix-bottom-btn" @click="gotodownload()">
    GB WhatsApp Download(v18.70)
  </div> -->
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import 'swiper/css/swiper.css';

export default {
  name: 'Home',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'home',
      tableHide: true,
      comment: {
        name: '',
        email: '',
        content: '',
      },
      showapk: false,
      // 目录默认折叠
      showTableOfContents: false,
      tocItems: [
        { id: 'whats-new', label: "What's New in GB WhatsApp v18.80" },
        { id: 'worth-downloading', label: 'Is GB WhatsApp Worth Downloading?' },
        { id: 'features', label: 'Features of GB WhatsApp Mod' },
        { id: 'requirements', label: 'Requirements to Install GB WhatsApp' },
        { id: 'download-install', label: 'How to Download And Install GB WhatsApp APK 2026' },
        { id: 'old-version', label: 'GB WhatsApp Old Version Download' },
        { id: 'safety', label: 'Safety and Privacy Considerations' },
        { id: 'comparison', label: 'GB WhatsApp vs Official WhatsApp' },
        { id: 'tutorials', label: 'Tutorials' },
        { id: 'alternatives', label: 'GB WhatsApp Alternatives' },
        { id: 'faq', label: 'Frequently Asked Questions (FAQs)' },
        { id: 'conclusion', label: 'Conclusion' },
        { id: 'gb-link', label: 'GB WhatsApp link' },
      ],

      apk: null,
      from: 'gb',
      filename: 'gb',
      clickNum: 0,
      selectedLanguage: 'en',
      openFaqIndex: 0,
      faqItems: [
        {
          question: 'Q1: Is GBWhatsApp safe to use?',
          answerLabel: 'A1:',
          answer: "GB WhatsApp is generally safe if downloaded from trusted sources, but it's still a modified app. Users should be aware of potential privacy risks and the possibility of account bans.",
        },
        {
          question: 'Q2: Can I use GBWhatsApp alongside the official WhatsApp?',
          answerLabel: 'A2:',
          answer: 'Yes. GB WhatsApp supports dual accounts, allowing you to run both apps on the same device without conflicts.',
        },
        {
          question: 'Q3: How do I update GBWhatsApp?',
          answerLabel: 'A3:',
          answer: 'Check the update option inside GB Settings or download the latest APK from a trusted source and install it manually.',
        },
        {
          question: 'Q4: Can I view deleted messages in GBWhatsApp?',
          answerLabel: 'A4:',
          answer: 'Yes, with the Anti-Delete Messages feature, you can view messages and statuses deleted by others.',
        },
        {
          question: 'Q5: Is GB WhatsApp available for iOS?',
          answerLabel: 'A5:',
          answer: 'No. GBWhatsApp is designed for Android, and iOS restrictions prevent its official release on the App Store.',
        },
      ],
    };
  },
  computed: {
    downloadURL() {
      // var params = window.location.search;
      // return `/gbwhatsapp-apk-download${params}`;
      if (typeof window === 'undefined') {
        // Server-side rendering logic
        return '/gbwhatsapp-apk-download'; // Adjust this based on your server-side logic
      } else {
        // Client-side rendering logic
        let params = window.location.search;
        return `/gbwhatsapp-apk-download${params}`;
      }
    },
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }

 

    // window.adsTag.renderInterstitial(54982);
  },
  methods: {
    downloadClick() {
      this.$router.push({
        name: 'en-download'
      });
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      window.location.href = '/download/';
      // console.log(this.apk);
      // // this.showapk = true
      // if (this.apk) {
      //   this.$global.download(this.apk);
      // }

    },
    gotoblog() {
      window.location.href = '/blogs';
    },
    jump(url) {
      window.location.href = url;
    },
    toggleFaq(index) {
      this.openFaqIndex = this.openFaqIndex === index ? null : index;
    },
  
  },
};
</script>

<style lang="scss" scoped>
#maincontent {
  --home-section-y: 44px;
  --home-section-y-compact: 30px;
  --home-block-gap: 22px;
  --home-card-gap: 16px;
  background: #ffffff;
}
/* 阅读体验：字号 / 行高 / 间距 */
h1 {
  font-size: 2.25rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1.25rem;
  text-align: center;
  line-height: 1.25;
  letter-spacing: 0;
}

h2 {
  position: relative;
  font-size: 1.65rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 1rem 0;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 0.6rem;
  line-height: 1.35;
  scroll-margin-top: 80px;
}

h2::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 72px;
  height: 2px;
  border-radius: 999px;
  background: var(--brand-primary, #06c755);
}

h3 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #374151;
  margin: 1.5rem 0 0.65rem 0;
  line-height: 1.4;
  scroll-margin-top: 80px;
}

h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #4b5563;
  margin: 1rem 0 0.5rem 0;
}

/* 外层铺满，内层 .container 与导航同宽，避免 80% 套 80% */
#page.container {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;
}

/* 正文：与导航同宽 */
.hero-section .container,
.toc-section .container,
.whats-new-section .container,
.worth-downloading-section .container,
.features-section .container,
.enhanced-features-section .container,
.call-id-section .container,
.requirements-section .container,
.download-install-section .container,
.old-version-section .container,
.safety-privacy-section .container,
.comparison-section .container,
.tutorial-section .container,
.alternatives-section .container,
.faq-section .container,
.conclusion-section .container,
.link-section .container {
  width: 80%;
  max-width: none;
  margin: 0 auto;
  padding: var(--home-section-y) 0;
  box-sizing: border-box;
}

.safety-privacy-section,
.faq-section {
  background: #f8fafc;
  border-top: 1px solid #edf2f7;
  border-bottom: 1px solid #edf2f7;
}

.hero-section .container {
  padding-top: 34px;
  padding-bottom: 24px;
}

.hero-panel {
  overflow: hidden;
  padding: 2rem 2rem 1.65rem;
  background: linear-gradient(180deg, #f7fff9 0%, #ffffff 42%);
  border: 1px solid var(--brand-primary-border, #b7f3ca);
  border-top: 4px solid var(--brand-primary, #06c755);
  border-radius: 14px;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.06);
  text-align: center;
}

.hero-panel h1 {
  margin-top: 0;
}

.hero-copy {
  max-width: 760px;
  margin: 1.25rem auto 0;
  text-align: center;
}

.hero-copy p {
  margin: 0 auto 0.75rem;
  color: #4b5563;
  text-align: center;
}

.hero-copy p:last-child {
  margin-bottom: 0;
}

.toc-section .container {
  padding: 14px 0;
}

.whats-new-section .container {
  padding-top: 30px;
}

/* 首屏段落内：指向当前首页的超链接 */
.hero-self-link {
  color: var(--brand-primary, #06c755);
  text-decoration: underline;
  text-underline-offset: 2px;
  transition: color 0.2s ease;

  strong {
    font-weight: 700;
  }

  &:hover {
    color: var(--brand-primary-hover, #05a949);
  }
}

/* 段落样式 */
p {
  font-size: 1.05rem;
  line-height: 1.8;
  margin-bottom: 1.1rem;
  color: #4b5563;
}

/* 列表样式 */
ul,
ol {
  margin: 1rem 0;
}

ul {
  padding-left: 0;
  list-style-position: inside;
}

ol {
  padding-left: 1.75rem;
}

li {
  margin-bottom: 0.55rem;
  line-height: 1.7;
  color: #4b5563;
  font-size: 1.05rem;
}

/* 下载按钮样式 */
.download-btn {
  background: linear-gradient(135deg, var(--brand-primary, #06c755), var(--brand-primary-hover, #05a949));
  color: white;
  border: none;
  padding: 14px 28px;
  font-size: 1.05rem;
  font-weight: 700;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.25s ease;
  margin: 1rem 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  text-decoration: none;
  line-height: 1.2;
}

.download-btn-icon {
  width: 1.15em;
  height: 1.15em;
  flex-shrink: 0;
}

.download-btn:hover {
  background: linear-gradient(135deg, var(--brand-primary-hover, #05a949), var(--brand-primary-dark, #048d3d));
  transform: translateY(-1px);
  box-shadow: 0 6px 16px var(--brand-primary-shadow, rgba(6, 199, 85, 0.24));
}

.download-button-container {
  text-align: center;
  margin: var(--home-block-gap) 0;
}

/* 首页：大图 GB Logo 与下方「GB WhatsApp App」区块之间的主下载按钮 */
.hero-download-below-main-logo {
  margin: 0.75rem auto 1.25rem;
}

/* 图片样式 */
.hero-image {
  text-align: center;
  margin: 0.5rem 0;
}

.apk-image {
  text-align: center;
  margin: var(--home-block-gap) 0 0;
}

.hero-image img, .apk-image img {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
}

/* 目录：默认折叠，点击展开（覆盖全局 #toc_container 灰底） */
#toc_container.home-toc {
  display: block;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.75rem 1rem;
  margin: 0;
}

#toc_container.home-toc .toc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin: 0;
  cursor: pointer;
  user-select: none;
  color: #1f2937;
  font-size: 1rem;
  line-height: 1.4;
}

#toc_container.home-toc .toc-toggle {
  color: var(--brand-primary, #06c755);
  font-size: 1.35rem;
  font-weight: 600;
  line-height: 1;
  min-width: 1.2em;
  text-align: center;
  user-select: none;
}

#toc_container.home-toc ul.toc-list {
  margin: 0.85rem 0 0.25rem;
  padding: 0;
  list-style: none;
  column-count: 2;
  column-gap: 1.5rem;
}

#toc_container.home-toc li {
  margin: 0;
  padding: 0.28rem 0;
  border: none;
  border-top: none;
  background: transparent;
  font-size: 0.95rem;
  line-height: 1.5;
  break-inside: avoid;
  -webkit-column-break-inside: avoid;
  page-break-inside: avoid;
}

#toc_container.home-toc a {
  display: flex;
  align-items: flex-start;
  gap: 0.35rem;
  color: var(--brand-primary, #06c755);
  text-decoration: none;
  text-shadow: none;
}

#toc_container.home-toc .toc-num {
  flex: 0 0 auto;
  min-width: 1.4em;
  color: #64748b;
  font-variant-numeric: tabular-nums;
}

#toc_container.home-toc .toc-label {
  flex: 1 1 auto;
}

#toc_container.home-toc a:hover {
  text-decoration: none;

  .toc-label {
    text-decoration: underline;
  }
}

.why-use-section,
.privacy-tips-section {
  margin-top: var(--home-section-y-compact);
  padding-top: var(--home-section-y-compact);
  border-top: 1px solid #e5e7eb;
}

@media (max-width: 768px) {
  #toc_container.home-toc ul.toc-list {
    column-count: 1;
  }
}

/* 功能特性样式 */
.feature-item {
  background: #f8f9fa;
  padding: 1.5rem;
  margin: var(--home-card-gap) 0 0;
  border-radius: 8px;
  border-left: 4px solid var(--brand-primary, #06c755);
}

.call-id-section .container > h3:first-child {
  position: relative;
  margin: 0 0 1rem;
  padding-bottom: 0.6rem;
  border-bottom: 1px solid #e5e7eb;
  color: #1f2937;
  font-size: 1.65rem;
  font-weight: 700;
  line-height: 1.35;
}

.call-id-section .container > h3:first-child::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 72px;
  height: 2px;
  border-radius: 999px;
  background: var(--brand-primary, #06c755);
}

/* 安装大步骤 timeline 补充（节点样式在 reading.scss） */
.call-id-section .container > ul {
  margin: 0;
  padding-left: 0;
  list-style-position: inside;
}

.call-id-section .container > strong {
  display: block;
  margin: 1.25rem 0 0.55rem;
  color: #1f2937;
  font-size: 1.02rem;
  line-height: 1.35;
}

.download-install-section.step-timeline .step {
  h3 {
    margin: 0.15rem 0 0.75rem;
    color: var(--read-text-strong, #1f2937);
    font-size: 1.15rem;
    line-height: 1.4;
  }

  > p:last-child {
    margin-bottom: 0;
  }

  ol,
  ul {
    margin-left: 0 !important;
  }
}

.download-install-section .update-section {
  background: var(--read-bg-soft, #f8fafc);
  border: 1px solid var(--read-border, #e5e7eb);
  border-radius: 10px;
  padding: 1.2rem 1.25rem;
  margin-top: var(--home-block-gap);
}

/* 教程步骤：普通清晰卡片，不用 timeline */
.tutorial-steps {
  position: relative;
  background: #ffffff;
  border: 1px solid #dbe5ef;
  border-top: 3px solid var(--brand-primary, #06c755);
  border-radius: 10px;
  padding: 1rem;
  margin: var(--home-card-gap) 0 0;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.05);

  > strong {
    display: block;
    width: 100%;
    box-sizing: border-box;
    margin: 1rem 0 0 !important;
    padding: 0.62rem 0.85rem;
    background: linear-gradient(90deg, var(--brand-primary-soft, #e8fff1), #ffffff);
    border: 1px solid var(--brand-primary-border, #b7f3ca);
    border-left: 4px solid var(--brand-primary, #06c755);
    border-radius: 8px 8px 0 0;
    color: var(--read-text-strong, #1f2937);
    font-size: 1rem;
    line-height: 1.35;

    &:first-child {
      margin-top: 0;
    }

    &::before {
      display: none;
      content: none;
    }
  }

  > ul {
    width: 100%;
    box-sizing: border-box;
    margin: 0 0 0.85rem !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    list-style: none !important;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-top: 0;
    border-radius: 0 0 8px 8px;
    padding: 0.72rem 0.85rem 0.72rem 0;
    padding-left: 0 !important;
    padding-inline-start: 0 !important;

    &::before {
      display: none;
      content: none;
    }

    li {
      position: relative;
      list-style: none !important;
      margin-bottom: 0.45rem;
      padding-left: 1.2rem;
      font-size: 1rem;
      line-height: 1.6;

      &::marker {
        content: "";
      }

      &::before {
        content: "";
        position: absolute;
        left: 0.45rem;
        top: 0.72em;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: var(--brand-primary, #06c755);
        transform: translateY(-50%);
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  > ol {
    counter-reset: tutorial-step;
    display: grid;
    gap: 0.7rem;
    margin: 0 !important;
    padding: 0 !important;
    list-style: none !important;

    > li {
      counter-increment: tutorial-step;
      position: relative !important;
      margin: 0 !important;
      padding: 0.8rem 0.95rem 0.8rem 3rem !important;
      background: #ffffff;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      color: var(--read-text, #374151);
      font-size: 1rem;
      line-height: 1.65;

      &::marker {
        content: "";
      }

      &::before {
        content: counter(tutorial-step);
        position: absolute;
        left: 0.9rem;
        top: 0.9rem;
        display: grid;
        place-items: center;
        width: 1.35rem;
        height: 1.35rem;
        border-radius: 50%;
        background: var(--brand-primary-soft, #e8fff1);
        border: 1px solid var(--brand-primary-border, #b7f3ca);
        color: var(--brand-primary-dark, #048d3d);
        font-size: 0.78rem;
        font-weight: 700;
        line-height: 1;
      }

      > ul {
        display: grid;
        gap: 0.38rem;
        margin: 0.65rem 0 0 !important;
        padding: 0 !important;
        list-style: none !important;

        > li {
          position: relative !important;
          margin: 0 !important;
          padding: 0 0 0 1rem !important;
          background: transparent;
          border: 0;
          color: var(--read-text, #374151);
          line-height: 1.6;

          &::marker {
            content: "";
          }

          &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 0.78em;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background: var(--brand-primary, #06c755);
            transform: translateY(-50%);
          }
        }
      }
    }
  }

  > p:last-child {
    margin-bottom: 0;
  }
}

.tutorial-item {
  margin-bottom: 0;
}

.tutorial-item + .tutorial-item {
  margin-top: var(--home-section-y-compact);
}

/* 表格样式 */
.table-container {
  overflow-x: auto;
  margin: var(--home-block-gap) 0 0;
  border: 1px solid #dbe3ee;
  border-top: 3px solid var(--brand-primary, #06c755);
  border-radius: 8px;
  background: #fff;
}

table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 0;
  overflow: hidden;
  box-shadow: none;
  font-size: var(--table-font-size, 1rem);
  line-height: var(--table-line-height, 1.6);
  letter-spacing: var(--table-letter-spacing, 0);
  border: none;
}

th, td {
  padding: var(--table-cell-pad-y, 0.65rem) var(--table-cell-pad-x, 0.85rem);
  text-align: left;
  border: none;
  border-bottom: 1px solid #eef2f7;
  border-right: 1px solid #eef2f7;
  font-weight: var(--table-font-weight, 400);
  vertical-align: top;
}

th:last-child,
td:last-child {
  border-right: none;
}

tr:last-child td {
  border-bottom: none;
}

th {
  background: #f1f5f9;
  color: #1f2937;
  font-weight: var(--table-th-weight, 600);
  border-bottom: 1px solid #dbe3ee;
  border-right-color: #dbe3ee;
}

th strong,
td strong {
  font-weight: 600;
}

tr:hover {
  background: #f8f9fa;
}

/* FAQ样式 */
.faq-accordion {
  display: grid;
  gap: 0.75rem;
  margin: var(--home-block-gap) 0 0;
}

.faq-item {
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #dbe5ef;
  border-radius: 8px;
  box-shadow: 0 10px 28px rgba(31, 41, 55, 0.06);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.faq-item.is-open {
  border-color: var(--brand-primary, #06c755);
  box-shadow: 0 14px 34px rgba(6, 199, 85, 0.14);
}

.faq-question {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  min-height: 64px;
  padding: 1.05rem 1.25rem;
  border: 0;
  background: #f8fafc;
  color: #4b5563;
  font: inherit;
  font-size: 1.08rem;
  font-weight: 400;
  line-height: 1.35;
  text-align: left;
  cursor: pointer;
}

.faq-question:hover,
.faq-question:focus-visible {
  background: var(--brand-primary-soft, #e8fff1);
}

.faq-question:focus-visible {
  outline: 3px solid rgba(6, 199, 85, 0.28);
  outline-offset: -3px;
}

.faq-icon {
  position: relative;
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--brand-primary, #06c755);
}

.faq-icon::before,
.faq-icon::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12px;
  height: 2px;
  border-radius: 999px;
  background: #ffffff;
  transform: translate(-50%, -50%);
  transition: transform 0.2s ease;
}

.faq-icon::after {
  transform: translate(-50%, -50%) rotate(90deg);
}

.faq-item.is-open .faq-icon::after {
  transform: translate(-50%, -50%) rotate(0deg);
}

.faq-answer {
  padding: 0 1.25rem 1.2rem;
  background: #ffffff;
}

.faq-answer p {
  margin: 0;
  color: #4b5563;
  line-height: 1.75;
}

/* 2 列网格（Safety / Alternatives） */
.card-grid--2x2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--home-card-gap);
  margin: var(--home-block-gap) 0 0;
}

.card-grid--2x2 .safety-item,
.card-grid--2x2 .alternative-item {
  margin: 0;
  height: 100%;
  box-sizing: border-box;
}

/* 卡片项：去掉左侧黄边 */
.comparison-item,
.alternative-item,
.safety-item {
  background: #f8fafc;
  padding: 1.2rem 1.25rem;
  margin: var(--home-card-gap) 0 0;
  border-radius: 10px;
  border: 1px solid #e8eef5;
  border-top: 3px solid var(--brand-primary-border, #b7f3ca);
  border-left: none;

  .comparison-item-title {
    font-weight: 700;
    font-size: 1.25rem;
    color: #1f2937;
  }

  h3 {
    margin-top: 0;
    margin-bottom: 0.55rem;
    font-size: 1.2rem;
    font-weight: 700;
    color: #1f2937;
    line-height: 1.35;
  }

  p {
    font-size: 0.95rem;
    font-weight: 400;
    color: #6b7280;
    line-height: 1.7;
  }

  p:last-child {
    margin-bottom: 0;
  }

  strong {
    color: #4b5563;
    font-weight: 600;
  }
}

.alternative-item h3 a {
  /* 有链接：默认绿色，一看就能点 */
  color: var(--brand-primary, #06c755);
  font-weight: 700;
  text-decoration: none;
  transition: color 0.2s;
}

.alternative-item h3 a:hover {
  color: var(--brand-primary-hover, #05a949);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.alternatives-section .card-grid--2x2 {
  grid-template-columns: 1fr;
  gap: 0.85rem;
}

.alternatives-section .alternative-item {
  display: block;
  padding: 1rem 1.15rem;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-left: 4px solid var(--brand-primary, #06c755);
  border-top: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.04);
}

.alternatives-section .alternative-item h3 {
  margin: 0 0 0.45rem;
  font-size: 1.08rem;
  line-height: 1.35;
  text-align: left;
}

.alternatives-section .alternative-item p {
  margin: 0;
  font-size: 0.98rem;
  line-height: 1.65;
  color: #4b5563;
  text-align: left;
}

@media (max-width: 768px) {
  .card-grid--2x2 {
    grid-template-columns: 1fr;
  }
}

/* 应用详情表格样式 */
.app-details-section {
  margin: var(--home-block-gap) 0 0;
}

.app-details-section h3 {
  margin-bottom: 1rem;
  text-align: center;
}

.app-details-section table {
  margin: 0 auto;
}

.app-details-section td:first-child {
  background: #f8f9fa;
  font-weight: bold;
  width: 40%;
}

.app-details-section td:last-child {
  background: white;
  color: #333;
}

/* 旧版本表格样式 */
.old-version-section {
  margin: 0;
}

.old-version-section h2 {
  margin-bottom: 1rem;
  /* text-align: center; */
}

.old-version-section p {
  text-align: center;
  margin-bottom: var(--home-block-gap);
  color: #666;
  font-style: italic;
}

/* Enhanced Features Section */
.enhanced-features-section {
  background: #ffffff;
  padding: 0;
  margin: 0;
  border: 0;
}

.enhanced-feature-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--home-card-gap);
  margin-bottom: 1.5rem;
}

/* 同一标题下：卡片在上、表格在下的间距 */
.features-section .features-table-below-cards {
  margin-top: 0.25rem;
}

.enhanced-feature-card {
  min-height: 100%;
  padding: 1.15rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-top: 3px solid var(--brand-primary-border, #b7f3ca);
  border-radius: 8px;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.04);
}

.enhanced-feature-card h3 {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: var(--read-text-strong, #1f2937);
  margin: 0 0 0.55rem;
  font-size: 0.9rem;
  line-height: 1.25;
  white-space: normal;
  overflow-wrap: anywhere;
}

.enhanced-feature-card h3::before {
  content: "";
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  border-radius: 7px;
  background-color: var(--brand-primary-soft, #e8fff1);
  background-image: var(--feature-card-icon);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 14px 14px;
  border: 1px solid var(--brand-primary-border, #b7f3ca);
}

.enhanced-feature-card:nth-child(1) {
  --feature-card-icon: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2306c755' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z'/%3E%3Cpath d='m9 12 2 2 4-4'/%3E%3C/svg%3E");
}

.enhanced-feature-card:nth-child(2) {
  --feature-card-icon: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2306c755' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='13.5' cy='6.5' r='.5'/%3E%3Ccircle cx='17.5' cy='10.5' r='.5'/%3E%3Ccircle cx='8.5' cy='7.5' r='.5'/%3E%3Ccircle cx='6.5' cy='12.5' r='.5'/%3E%3Cpath d='M12 22C6.5 22 2 17.5 2 12S6.5 2 12 2c5 0 9 3.5 9 8 0 2.2-1.8 4-4 4h-1.5c-.8 0-1.5.7-1.5 1.5 0 .4.2.8.4 1.1.3.3.4.7.4 1.1 0 1.3-1.1 2.3-2.8 2.3z'/%3E%3C/svg%3E");
}

.enhanced-feature-card:nth-child(3) {
  --feature-card-icon: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2306c755' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect width='18' height='18' x='3' y='3' rx='2' ry='2'/%3E%3Ccircle cx='9' cy='9' r='2'/%3E%3Cpath d='m21 15-3.1-3.1a2 2 0 0 0-2.8 0L6 21'/%3E%3C/svg%3E");
}

.enhanced-feature-card:nth-child(4) {
  --feature-card-icon: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2306c755' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2'/%3E%3Ccircle cx='9' cy='7' r='4'/%3E%3Cpath d='M22 21v-2a4 4 0 0 0-3-3.87'/%3E%3Cpath d='M16 3.13a4 4 0 0 1 0 7.75'/%3E%3C/svg%3E");
}

.enhanced-feature-card:nth-child(5) {
  --feature-card-icon: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2306c755' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cpolyline points='12 6 12 12 16 14'/%3E%3Cpath d='M8 2v4'/%3E%3Cpath d='M16 2v4'/%3E%3C/svg%3E");
}

.enhanced-feature-card:nth-child(6) {
  --feature-card-icon: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2306c755' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect width='18' height='11' x='3' y='11' rx='2' ry='2'/%3E%3Cpath d='M7 11V7a5 5 0 0 1 10 0v4'/%3E%3Cpath d='m8 16 2 2 6-6'/%3E%3C/svg%3E");
}

.enhanced-feature-card:nth-child(7) {
  --feature-card-icon: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2306c755' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M12 3v12'/%3E%3Cpath d='m7 10 5 5 5-5'/%3E%3Cpath d='M5 21h14'/%3E%3C/svg%3E");
}

.enhanced-feature-card:nth-child(8) {
  --feature-card-icon: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2306c755' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M13 2 3 14h8l-1 8 11-14h-8l1-6z'/%3E%3C/svg%3E");
}

.enhanced-feature-card p {
  margin: 0;
  font-size: 0.95rem;
  line-height: var(--read-lh, 1.8);
  color: var(--read-text, #374151);
}

/* 响应式设计 */
@media (max-width: 768px) {
  h1 {
    font-size: 1.75rem;
  }
  
  h2 {
    font-size: 1.4rem;
  }
  
  h3 {
    font-size: 1.15rem;
  }

  .call-id-section .container > h3:first-child {
    font-size: 1.4rem;
  }

  p, li {
    font-size: 1rem;
  }
  
  .hero-section .container,
  .toc-section .container,
  .whats-new-section .container,
  .worth-downloading-section .container,
  .features-section .container,
  .enhanced-features-section .container,
  .call-id-section .container,
  .requirements-section .container,
  .download-install-section .container,
  .old-version-section .container,
  .safety-privacy-section .container,
  .comparison-section .container,
  .tutorial-section .container,
  .alternatives-section .container,
  .faq-section .container,
  .conclusion-section .container,
  .link-section .container {
    width: 100%;
    padding: var(--home-section-y-compact) 16px;
  }

  .hero-section .container {
    padding-bottom: 18px;
  }

  .hero-panel {
    padding: 1.4rem 1rem 1.25rem;
    border-radius: 12px;
  }

  .toc-section .container {
    padding: 12px 16px;
  }

  .whats-new-section .container {
    padding-top: 24px;
  }
  
  .download-btn {
    padding: 12px 24px;
    font-size: 1rem;
  }
  
  .enhanced-features-section {
    padding: 0;
  }

  .enhanced-feature-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

}

@media (max-width: 520px) {
  .enhanced-feature-grid {
    grid-template-columns: 1fr;
  }
}
</style>
